export default "__VITE_ASSET__D1Mw21Wo__"